// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams, useLocation } from 'react-router-dom';
// import tenderDetailsFormImage from '../../Assets/images/tenderDetailsFormImage.png';
// import { AiOutlineClose } from 'react-icons/ai';
// import Swal from 'sweetalert2';
// import apiClient from '../../Api/apiClient';
// import { PHOTO_BASE_URL_Admin } from '../../Api/config';
// import { Printer, FileText } from "lucide-react";

// const TenderDetails = () => {
//   const location = useLocation();
//   const { FromFreeTenders } = location.state || {};
//   const navigate = useNavigate();
//   const { id } = useParams();



//   console.log('FromFreeTenders value:', FromFreeTenders);

//   // State for form data and auxiliary inputs
//   const [formData, setFormData] = useState({
//     org_company_name: '',
//     reference_number: '',
//     earnest_money: '',
//     documents_price: '',
//     publish_on: '',
//     opening_date: '',
//     end_date: '',
//     purchase_last_date: '',
//     prebid_meeting_date: '',
//     prebid_meeting_end_date: '',
//     proposal_closing_date: '',
//     submission_date: '',
//     status: '',
//     tender_section: '',
//     type: '',
//     address: '',
//     sub_sector_id: '',
//     sub_department_id: '',
//     source_id: '',
//     upazila_id: '',
//     description: '',
//     call_type: '',
//     tender_on: '',
//     tender_pattern: '',
//   });
//   const [fileInput, setFileInput] = useState(null);
//   const [logoInput, setLogoInput] = useState(null);
//   const [logo, setLogo] = useState(null);
//   const [orgName, setOrgname] = useState('');
//   const [tenderName, setTenderName] = useState('');

//   const [loading, setLoading] = useState(true);


//   console.log('id:', id);
//   useEffect(() => {
//     const fetchTenderDetails = async () => {
//       try {
//         setLoading(true); // 👉 API কল শুরু হলে loading true হবে
//         const url = FromFreeTenders
//           ? `/user/tender-user/free/${id}`
//           : `/user/tender-end-user/tender-view/${id}`;

//         const response = await apiClient.get(url);
//         const data = response.data.data;

//         console.log('Free tender single details:', data);

//         setOrgname(data.org_company_name);
//         setTenderName(data.name);
//         setLogo(data.company_logo);

//         setFormData(prevFormData => ({
//           ...prevFormData,
//           ...data, // Populate formData with fetched data
//         }));

//         console.log('Fetched Tender Details:', data);
//       } catch (error) {
//         console.error('Error fetching tender details:', error);
//       }finally {
//         setLoading(false); // 👉 ডাটা লোড হয়ে গেলে loading false হবে
//       }
//     };

//     fetchTenderDetails();
//   }, [id]);

//   // Handle input change
//   const handleInputChange = e => {
//     const { name, value } = e.target;

//     // Convert numeric fields to numbers if necessary
//     const numericFields = [
//       'sub_sector_id',
//       'sub_department_id',
//       'source_id',
//       'upazila_id',
//     ];
//     setFormData(prevData => ({
//       ...prevData,
//       [name]: numericFields.includes(name)
//         ? value
//           ? Number(value)
//           : ''
//         : value,
//     }));
//   };

//   // Handle file upload
//   const handleFileUpload = (e, setFile) => {
//     const file = e.target.files[0];
//     if (file) setFile(file);
//   };

//   // Handle form submission
//   const handleSubmit = async e => {
//     e.preventDefault();

//     // Prepare form data
//     const updateData = new FormData();

//     // Append fields conditionally, ensuring valid types
//     updateData.append('name', formData.name || '');
//     updateData.append(
//       'sub_sector_id',
//       formData.sub_sector_id ? Number(formData.sub_sector_id) : ''
//     ); // Ensure number or omit
//     updateData.append(
//       'sub_department_id',
//       formData.sub_department_id ? Number(formData.sub_department_id) : ''
//     );
//     updateData.append(
//       'source_id',
//       formData.source_id ? Number(formData.source_id) : ''
//     );
//     updateData.append(
//       'upazila_id',
//       formData.upazila_id ? Number(formData.upazila_id) : ''
//     );

//     // Append other fields (similarly for all fields)
//     updateData.append('earnest_money', formData.earnest_money || '');
//     updateData.append('tender_section', formData.tender_section || '');
//     updateData.append('documents_price', formData.documents_price || '');
//     updateData.append('publish_on', formData.publish_on || '');
//     updateData.append('opening_date', formData.opening_date || '');
//     updateData.append('end_date', formData.end_date || '');
//     updateData.append('purchase_last_date', formData.purchase_last_date || '');

//     updateData.append(
//       'prebid_meeting_date',
//       formData.prebid_meeting_date || ''
//     );
//     updateData.append(
//       'prebid_meeting_end_date',
//       formData.prebid_meeting_end_date || ''
//     );
//     updateData.append(
//       'proposal_closing_date',
//       formData.proposal_closing_date || ''
//     );
//     updateData.append('submission_date', formData.submission_date || '');
//     updateData.append('address', formData.address || '');
//     updateData.append('call_type', formData.call_type || '');
//     updateData.append('tender_on', formData.tender_on || '');
//     updateData.append('tender_pattern', formData.tender_pattern || '');

//     // File uploads
//     if (fileInput instanceof File) {
//       updateData.append('file_upload', fileInput);
//     }
//     if (logoInput instanceof File) {
//       updateData.append('company_logo', logoInput);
//     }

//     console.log(
//       'Final updateData before submission:',
//       Object.fromEntries(updateData)
//     );

//     try {
//       // Submit the form data
//       const response = await apiClient.patch(
//         `/admin/tender/${id}/`,
//         updateData
//       );

//       Swal.fire({
//         title: 'Success!',
//         text: response?.data?.message || 'Tender updated successfully.',
//         icon: 'success',
//       });

//       // Navigate or refresh after success
//       navigate('/tenderList');
//     } catch (error) {
//       // Handle errors and display message
//       if (error.response) {
//         Swal.fire({
//           title: 'Error!',
//           text: error.response.data.message || 'Failed to update tender.',
//           icon: 'error',
//         });
//         console.error('Error response:', error.response.data);
//       } else {
//         console.error('Error submitting form:', error);
//       }
//     }
//   };

//   const handlePDFview = id => {
//     navigate(`/pdf-viewer/${id}`);
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <p className="text-lg font-bold">Loading...</p>
//       </div>
//     );
//   }


//   return (
//     <>
//         <div className="p-0 md:px-10 2xl:px-10 bg-white min-h-screen rounded-lg shadow-sm mt-36 container mx-auto text-xs">
//           <div className="flex items-center justify-center mb-6 2xl:mb-8 mt-0">
//             <img
//               src={tenderDetailsFormImage}
//               alt="Tender Details Form"
//               className="h-32 2xl:h-40"
//             />
//           </div>

//           <div className='flex items-end justify-end mb-2 space-x-2'>
//             <button
//               onClick={() => handlePDFview(id)}
//               className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
//             >
//               <FileText className="w-5 h-5" />
//               View PDF
//             </button>

//             <button
//               onClick={() => window.print()}
//               className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
//             >
//               <Printer className="w-5 h-5" />
//               Print
//             </button>
//           </div>

//           <div className="bg-tenderDetails shadow-md rounded-md md:p-6 p-2 border border-blue-300">


//             <div className="flex justify-between items-center mb-6">
//               <div className="flex items-center space-x-4">
//                 <img
//                   src={
//                     logo
//                       ? `${PHOTO_BASE_URL_Admin}${logo}`
//                       : 'https://via.placeholder.com/50'
//                   }
//                   alt="Organization Logo"
//                   className="w-16 h-16 rounded-full"
//                 />
//                 <div>
//                   <h2 className="text-lg font-bold">{tenderName}</h2>
//                   <p className="text-gray-500">{orgName}</p>
//                 </div>
//               </div>
//             </div>

//             {/* Form */}
//             <form onSubmit={handleSubmit}>
//               <div className="grid md:grid-cols-2  grid-cols-1 2xl:gap-x-28 md:gap-x-16 gap-x-4 2xl:gap-y-5 gap-y-3">
//                 {[
//                   { label: 'Tender Section', name: 'tender_section', type: 'text' },

//                   {
//                     label: 'Reference Number',
//                     name: 'ref_no',
//                     type: 'text',
//                   },
//                   {
//                     label: 'Org/Company Name',
//                     name: 'invitation_for',
//                     type: 'text',
//                   },
//                   { label: 'Tender Pattern', name: 'tender_pattern', type: 'text' },
//                   { label: 'Type', name: 'type', type: 'text' },
//                   { label: 'Call Type', name: 'call_type', type: 'text' },
//                   { label: 'Tender On', name: 'tender_on', type: 'text' },

//                   { label: 'Source Type', name: 'source_type', type: 'text' },
//                   { label: 'Source Name', name: 'source_name', type: 'text' },
//                   {
//                     label: 'Department Name',
//                     name: 'department_name',
//                     type: 'text',
//                   },
//                   {
//                     label: 'Sub-department Name',
//                     name: 'sub_department_name',
//                     type: 'text',
//                   },
//                   { label: 'Category Name', name: 'category_name', type: 'text' },
//                   { label: 'Sector Name', name: 'sector_name', type: 'text' },
//                   {
//                     label: 'Sub-sector Name',
//                     name: 'sub_sector_name',
//                     id: 'sub_sector_id',
//                     type: 'text',
//                   },
//                   { label: 'Division Name', name: 'division_name', type: 'text' },
//                   { label: 'District Name', name: 'district_name', type: 'text' },
//                   { label: 'Upazila Name', name: 'upazila_name', type: 'text' },
//                   { label: 'Published on', name: 'publish_on', type: 'text' },
//                   {
//                     label: 'Purchase Last Date',
//                     name: 'purchase_last_date',
//                     type: 'text',
//                   },
//                   {
//                     label: 'Prebid Meeting Start Date',
//                     name: 'prebid_meeting_date',
//                     type: 'text',
//                   },
//                   {
//                     label: 'Prebid Meeting End Date',
//                     name: 'prebid_meeting_end_date',
//                     type: 'text',
//                   },
//                   {
//                     label: 'Proposal Closing Date',
//                     name: 'proposal_closing_date',
//                     type: 'text',
//                   },
//                   { label: 'Opening Date', name: 'opening_date', type: 'text' },
//                   {
//                     label: 'Submission Date',
//                     name: 'submission_date',
//                     type: 'text',
//                   },
//                   { label: 'Address', name: 'address', type: 'text' },
//                   { label: 'Documents', name: 'file_upload', type: 'text' },

//                   { label: 'Earnest Money', name: 'earnest_money', type: 'text' },
//                   {
//                     label: 'Document Price',
//                     name: 'documents_price',
//                     type: 'text',
//                   },
//                   { label: 'Status', name: 'status', type: 'text' },

//                   { label: 'End Date', name: 'end_date', type: 'text' },

//                   { label: 'Create at', name: 'created_at', type: 'text' },
//                   { label: 'Description', name: 'description', type: 'text' },
//                   // { label: 'Documents', name: 'file_upload', type: 'text' },
//                 ].filter(({ name }) => formData[name] && formData[name] !== 'N/A')
//                   .map(({ label, name, type }) => (
//                     <div
//                       key={name}
//                       className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0 space-y-2"
//                     >
//                       <label
//                         htmlFor={name}
//                         className="block text-sm font-medium text-gray-700 w-full sm:w-1/3"
//                       >
//                         {label}:
//                       </label>

//                       {label === 'Documents' ? (
//                         <div className="flex flex-col sm:flex-row sm:items-center gap-1 w-full">
//                           <input
//                             id={name}
//                             name={name}
//                             type="text" // Assuming the file URL is stored as text
//                             value={formData[name] || 'N/A'}
//                             onChange={handleInputChange}
//                             className="p-2 border-2 rounded-md shadow-sm focus:outline-none focus:ring-0 text-xs w-full md:ml-12 2xl:ml-14 md:block hidden"
//                             readOnly
//                           />
//                           <a
//                             // href={`${PHOTO_BASE_URL_Admin}${formData[name]}`}
//                             // target="_blank"
//                             // rel="noopener noreferrer"
//                             onClick={() => handlePDFview(id)}
//                             className="flex justify-center items-center border border-gray-300 px-2 py-2 text-xs rounded-md shadow-sm w-full sm:w-1/3 bg-white text-black hover:text-blue-600 hover:border-blue-600 cursor-pointer"
//                           >
//                             📄 View PDF
//                           </a>
//                         </div>
//                       ) : (
//                         <input
//                           id={name}
//                           name={name}
//                           type={type}
//                           // value={formData[name] || 'N/A'}
//                           value={
//                             name === 'status'
//                               ? formData[name] === 1
//                                 ? 'Active'
//                                 : 'Expired'
//                               : formData[name] || 'N/A'
//                           }
//                           onChange={handleInputChange}
//                           // className="flex-1 p-2 border-2 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 text-xs"
//                           className="flex-1 p-2 border-2 rounded-md shadow-sm text-xs focus:outline-none focus:ring-0"
//                           readOnly
//                         />
//                       )}
//                     </div>
//                   ))}
//               </div>

//               {/* Buttons */}
//               <div className="mt-6 flex justify-end gap-4">
//                 <button
//                   type="button"
//                   onClick={() => navigate('/')}
//                   className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-red-600"
//                 >
//                   Close View
//                 </button>
//                 {/* <button
//             type="submit"
//             className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
//           >
//             Update
//           </button> */}
//               </div>
//             </form>
//           </div>
//         </div>  
//     </>
//   );
// };

// export default TenderDetails;




import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import tenderDetailsFormImage from '../../Assets/images/tenderDetailsFormImage.png';
import { AiOutlineClose } from 'react-icons/ai';
import Swal from 'sweetalert2';
import apiClient from '../../Api/apiClient';
import { PHOTO_BASE_URL_Admin } from '../../Api/config';
import { Printer, FileText } from "lucide-react";

const TenderDetails = () => {
  const location = useLocation();
  const { FromFreeTenders } = location.state || {};
  const navigate = useNavigate();
  const { id } = useParams();

  console.log('FromFreeTenders value:', FromFreeTenders);

  // State for form data and auxiliary inputs
  const [formData, setFormData] = useState({
    org_company_name: '',
    reference_number: '',
    earnest_money: '',
    documents_price: '',
    publish_on: '',
    opening_date: '',
    end_date: '',
    purchase_last_date: '',
    prebid_meeting_date: '',
    prebid_meeting_end_date: '',
    proposal_closing_date: '',
    submission_date: '',
    status: '',
    tender_section: '',
    type: '',
    address: '',
    sub_sector_id: '',
    sub_department_id: '',
    source_id: '',
    upazila_id: '',
    description: '',
    call_type: '',
    tender_on: '',
    tender_pattern: '',
  });
  const [fileInput, setFileInput] = useState(null);
  const [logoInput, setLogoInput] = useState(null);
  const [logo, setLogo] = useState(null);
  const [orgName, setOrgname] = useState('');
  const [tenderName, setTenderName] = useState('');
  const [loading, setLoading] = useState(true);

  console.log('id:', id);
  useEffect(() => {
    const fetchTenderDetails = async () => {
      try {
        setLoading(true); // 👉 API কল শুরু হলে loading true হবে
        const url = FromFreeTenders
          ? `/user/tender-user/free/${id}`
          : `/user/tender-end-user/tender-view/${id}`;

        const response = await apiClient.get(url);
        const data = response.data.data;

        console.log('Free tender single details:', data);

        setOrgname(data.org_company_name);
        setTenderName(data.name);
        setLogo(data.company_logo);

        setFormData(prevFormData => ({
          ...prevFormData,
          ...data, // Populate formData with fetched data
        }));

        console.log('Fetched Tender Details:', data);
      } catch (error) {
        console.error('Error fetching tender details:', error);
      } finally {
        setLoading(false); // 👉 ডাটা লোড হয়ে গেলে loading false হবে
      }
    };

    fetchTenderDetails();
  }, [id]);

  // Handle input change
  const handleInputChange = e => {
    const { name, value } = e.target;

    // Convert numeric fields to numbers if necessary
    const numericFields = [
      'sub_sector_id',
      'sub_department_id',
      'source_id',
      'upazila_id',
    ];
    setFormData(prevData => ({
      ...prevData,
      [name]: numericFields.includes(name)
        ? value
          ? Number(value)
          : ''
        : value,
    }));
  };

  // Handle file upload
  const handleFileUpload = (e, setFile) => {
    const file = e.target.files[0];
    if (file) setFile(file);
  };

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault();

    // Prepare form data
    const updateData = new FormData();

    // Append fields conditionally, ensuring valid types
    updateData.append('name', formData.name || '');
    updateData.append(
      'sub_sector_id',
      formData.sub_sector_id ? Number(formData.sub_sector_id) : ''
    ); // Ensure number or omit
    updateData.append(
      'sub_department_id',
      formData.sub_department_id ? Number(formData.sub_department_id) : ''
    );
    updateData.append(
      'source_id',
      formData.source_id ? Number(formData.source_id) : ''
    );
    updateData.append(
      'upazila_id',
      formData.upazila_id ? Number(formData.upazila_id) : ''
    );

    // Append other fields (similarly for all fields)
    updateData.append('earnest_money', formData.earnest_money || '');
    updateData.append('tender_section', formData.tender_section || '');
    updateData.append('documents_price', formData.documents_price || '');
    updateData.append('publish_on', formData.publish_on || '');
    updateData.append('opening_date', formData.opening_date || '');
    updateData.append('end_date', formData.end_date || '');
    updateData.append('purchase_last_date', formData.purchase_last_date || '');

    updateData.append(
      'prebid_meeting_date',
      formData.prebid_meeting_date || ''
    );
    updateData.append(
      'prebid_meeting_end_date',
      formData.prebid_meeting_end_date || ''
    );
    updateData.append(
      'proposal_closing_date',
      formData.proposal_closing_date || ''
    );
    updateData.append('submission_date', formData.submission_date || '');
    updateData.append('address', formData.address || '');
    updateData.append('call_type', formData.call_type || '');
    updateData.append('tender_on', formData.tender_on || '');
    updateData.append('tender_pattern', formData.tender_pattern || '');

    // File uploads
    if (fileInput instanceof File) {
      updateData.append('file_upload', fileInput);
    }
    if (logoInput instanceof File) {
      updateData.append('company_logo', logoInput);
    }

    console.log(
      'Final updateData before submission:',
      Object.fromEntries(updateData)
    );

    try {
      // Submit the form data
      const response = await apiClient.patch(
        `/admin/tender/${id}/`,
        updateData
      );

      Swal.fire({
        title: 'Success!',
        text: response?.data?.message || 'Tender updated successfully.',
        icon: 'success',
      });

      // Navigate or refresh after success
      navigate('/tenderList');
    } catch (error) {
      // Handle errors and display message
      if (error.response) {
        Swal.fire({
          title: 'Error!',
          text: error.response.data.message || 'Failed to update tender.',
          icon: 'error',
        });
        console.error('Error response:', error.response.data);
      } else {
        console.error('Error submitting form:', error);
      }
    }
  };

  const handlePDFview = id => {
    navigate(`/pdf-viewer/${id}`);
  };

  // Utility function to format date as 'dd-mmm-yyyy'
  const formatDate = (dateString) => {
    if (!dateString || ['0000-00-00', 'N/A', 'Null', 'null', 'undefined'].includes(dateString)) {
      return ''; // Return empty string for invalid or unwanted values
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return ''; // Return empty string for invalid dates
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-lg font-bold">Loading...</p>
      </div>
    );
  }

  return (
    <>
      <div className="p-0 md:px-10 2xl:px-10 bg-white min-h-screen rounded-lg shadow-sm mt-36 container mx-auto text-xs">
        <div className="flex items-center justify-center mb-6 2xl:mb-8 mt-0">
          <img
            src={tenderDetailsFormImage}
            alt="Tender Details Form"
            className="h-32 2xl:h-40"
          />
        </div>

        <div className='flex items-end justify-end mb-2 space-x-2'>
          <button
            onClick={() => handlePDFview(id)}
            className="flex items-center gap-2 bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition"
          >
            <FileText className="w-5 h-5" />
            View PDF
          </button>

          <button
            onClick={() => window.print()}
            className="flex items-center gap-2 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
          >
            <Printer className="w-5 h-5" />
            Print
          </button>
        </div>

        <div className="bg-tenderDetails shadow-md rounded-md md:p-6 p-2 border border-blue-300">
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center space-x-4">
              <img
                src={
                  logo
                    ? `${PHOTO_BASE_URL_Admin}${logo}`
                    : 'https://via.placeholder.com/50'
                }
                alt="Organization Logo"
                className="w-16 h-16 rounded-full"
              />
              <div>
                <h2 className="text-lg font-bold">{tenderName}</h2>
                <p className="text-gray-500">{orgName}</p>
              </div>
            </div>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <div className="grid md:grid-cols-2 grid-cols-1 2xl:gap-x-28 md:gap-x-16 gap-x-4 2xl:gap-y-5 gap-y-3">
              {
                [
                  { label: 'Tender Section', name: 'tender_section', type: 'text' },
                  { label: 'Reference Number', name: 'ref_no', type: 'text' },
                  { label: 'Org/Company Name', name: 'invitation_for', type: 'text' },
                  { label: 'Tender Pattern', name: 'tender_pattern', type: 'text' },
                  { label: 'Type', name: 'type', type: 'text' },
                  { label: 'Call Type', name: 'call_type', type: 'text' },
                  { label: 'Tender On', name: 'tender_on', type: 'text' },
                  { label: 'Source Type', name: 'source_type', type: 'text' },
                  { label: 'Source Name', name: 'source_name', type: 'text' },
                  { label: 'Department Name', name: 'department_name', type: 'text' },
                  { label: 'Sub-department Name', name: 'sub_department_name', type: 'text' },
                  { label: 'Category Name', name: 'category_name', type: 'text' },
                  { label: 'Sector Name', name: 'sector_name', type: 'text' },
                  { label: 'Sub-sector Name', name: 'sub_sector_name', id: 'sub_sector_id', type: 'text' },
                  { label: 'Division Name', name: 'division_name', type: 'text' },
                  { label: 'District Name', name: 'district_name', type: 'text' },
                  { label: 'Upazila Name', name: 'upazila_name', type: 'text' },
                  { label: 'Published on', name: 'publish_on', type: 'text' },
                  { label: 'Purchase Last Date', name: 'purchase_last_date', type: 'text' },
                  { label: 'Prebid Meeting Start Date', name: 'prebid_meeting_date', type: 'text' },
                  { label: 'Prebid Meeting End Date', name: 'prebid_meeting_end_date', type: 'text' },
                  { label: 'Proposal Closing Date', name: 'proposal_closing_date', type: 'text' },
                  { label: 'Opening Date', name: 'opening_date', type: 'text' },
                  { label: 'Submission Date', name: 'submission_date', type: 'text' },
                  { label: 'Address', name: 'address', type: 'text' },
                  { label: 'Documents', name: 'file_upload', type: 'text' },
                  { label: 'Earnest Money', name: 'earnest_money', type: 'text' },
                  { label: 'Document Price', name: 'documents_price', type: 'text' },
                  { label: 'Status', name: 'status', type: 'text' },
                  { label: 'End Date', name: 'end_date', type: 'text' },
                  { label: 'Create at', name: 'created_at', type: 'text' },
                  { label: 'Description', name: 'description', type: 'text' },
                ]
                  .filter(({ name }) => {
                    const value = formData[name];
                    return (
                      value &&
                      value !== 'N/A' &&
                      value !== 'Null' &&
                      value !== '0000-00-00' &&
                      (name.includes('date') || name === 'publish_on' || name === 'created_at' ? formatDate(value) !== '' : true)
                    );
                  })
                  .map(({ label, name, type }) => (
                    <div
                      key={name}
                      className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 sm:space-y-0 space-y-2"
                    >
                      <label
                        htmlFor={name}
                        className="block text-sm font-medium text-gray-700 w-full sm:w-1/3"
                      >
                        {label}:
                      </label>

                      {label === 'Documents' ? (
                        <div className="flex flex-col sm:flex-row sm:items-center gap-1 w-full">
                          <input
                            id={name}
                            name={name}
                            type="text"
                            value={formData[name] || 'N/A'}
                            onChange={handleInputChange}
                            className="p-2 border-2 rounded-md shadow-sm focus:outline-none focus:ring-0 text-xs w-full md:ml-12 2xl:ml-14 md:block hidden"
                            readOnly
                          />
                          <a
                            onClick={() => handlePDFview(id)}
                            className="flex justify-center items-center border border-gray-300 px-2 py-2 text-xs rounded-md shadow-sm w-full sm:w-1/3 bg-white text-black hover:text-blue-600 hover:border-blue-600 cursor-pointer"
                          >
                            📄 View PDF
                          </a>
                        </div>
                      ) : (
                        <input
                          id={name}
                          name={name}
                          type={type}
                          value={
                            name === 'status'
                              ? formData[name] === 1
                                ? 'Active'
                                : 'Expired'
                              : name.includes('date') || name === 'publish_on' || name === 'created_at'
                                ? formatDate(formData[name])
                                : formData[name] || 'N/A'
                          }
                          onChange={handleInputChange}
                          className="flex-1 p-2 border-2 rounded-md shadow-sm text-xs focus:outline-none focus:ring-0"
                          readOnly
                        />
                      )}
                    </div>
                  ))
              }
            </div>

            {/* Buttons */}
            <div className="mt-6 flex justify-end gap-4">
              <button
                type="button"
                onClick={() => navigate('/')}
                className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-red-600"
              >
                Close View
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default TenderDetails;